import { connect } from 'react-redux'
import { IStoreState, IAssistanceObject } from '../../types/index'
import { getAssistances, createAssistance } from 'src/state/actions/assistance'
import AddAssistanceModal from 'src/components/global-settings/AddAssistanceModal'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    categories: state.assistanceCategories.items
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    create: (assistance: IAssistanceObject) => {
      return dispatch(createAssistance(assistance))
    },
    getAssistances: () => {
      return dispatch(getAssistances())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddAssistanceModal)



// WEBPACK FOOTER //
// ./src/containers/global-settings/AddAssistanceModal.ts